import { registerModal } from 'features/Modal/ModalRegistry'
import BillingCreateFormModal from './BillingCreateFormModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'BILLING_CREATE_MODAL'
registerModal(modalType, BillingCreateFormModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
      hideClose: true,
      noClickClose: true,
    },
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingCreateFormModal/BillingCreateFormModal.action.js